<template>
    <v-row justify="space-between" align="center" class="legendHead mx-auto">
      <h3>{{ preferenceText }}</h3>
      <div @click="() => this.$emit('toggleTab')">
        <v-icon color="#58e2c2" size="25" v-if="!toggleTab">add</v-icon>
        <v-icon class="icon-top" color="#58e2c2" size="25" v-if="toggleTab"
          >maximize</v-icon
        >
      </div>
    </v-row>
</template>
<script>
export default {
    name: 'VirusStateHeader',
    props: ['preferenceText', 'toggleTab']
};
</script>
<style scoped>
.legendHead {
  margin-top: 0px;
}
</style>